var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _circle, _circle2, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMevProtectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 158,
    viewBox: "0 0 224 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1758 15V149",
    stroke: "url(#paint0_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2383 15V149",
    stroke: "url(#paint1_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3047 15V149",
    stroke: "url(#paint2_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.375 15V149",
    stroke: "url(#paint3_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.441 15V149",
    stroke: "url(#paint4_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.508 15V149",
    stroke: "url(#paint5_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.574 15V149",
    stroke: "url(#paint6_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.637 15V149",
    stroke: "url(#paint7_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.847656 132.543H223.353",
    stroke: "url(#paint8_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.847656 111.387L223.353 111.387",
    stroke: "url(#paint9_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.847656 90.2266L223.353 90.2266",
    stroke: "url(#paint10_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.847656 69.0703L223.353 69.0703",
    stroke: "url(#paint11_linear_1877_14573)",
    strokeOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.847656 47.9102L223.353 47.9102",
    stroke: "url(#paint12_linear_1877_14573)",
    strokeOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter0_f_1877_14573)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182.191 66.4885C187.499 66.4886 196.788 67.4861 199.442 64.4285C202.43 60.9861 207.404 61.9995 212.712 61.75",
    stroke: "url(#paint13_linear_1877_14573)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter1_f_1877_14573)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M182.191 86.7963C187.499 86.7962 196.788 85.7155 199.442 89.028C202.43 92.7573 207.404 91.6594 212.712 91.9297",
    stroke: "url(#paint14_linear_1877_14573)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter2_f_1877_14573)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M176.827 72.4938C172.38 72.4938 166.365 71.7405 163.488 73.7492C160.437 75.8791 160.872 80.7798 144.656 80.0265",
    stroke: "url(#paint15_linear_1877_14573)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter3_f_1877_14573)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3672 65.7466C37.0012 65.7466 27.6106 66.8372 24.9276 63.4945C21.907 59.7313 16.8786 60.8391 11.5125 60.5664",
    stroke: "url(#paint16_linear_1877_14573)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter4_f_1877_14573)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3672 86.894C37.0012 86.894 27.6106 85.8035 24.9276 89.1461C21.907 92.9093 16.8786 91.8015 11.5125 92.0742",
    stroke: "url(#paint17_linear_1877_14573)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter5_f_1877_14573)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.111 72.595C51.5395 72.595 57.5309 71.8437 60.3964 73.847C63.4348 75.9712 63.0014 80.8586 79.1523 80.1074",
    stroke: "url(#paint18_linear_1877_14573)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1877_14573)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.935,
    cy: 79.4098,
    rx: 44.7986,
    ry: 44.8825,
    fill: "#7600FC",
    fillOpacity: 0.25
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 111.772,
    cy: 79.7719,
    r: 30.5719,
    stroke: "white",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 63.6,
    y: 31.6,
    width: 95.8,
    height: 95.8
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12.2px)",
      clipPath: "url(#bgblur_0_1877_14573_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 24.4,
    cx: 111.5,
    cy: 79.5,
    r: 23.5,
    fill: "url(#paint19_radial_1877_14573)",
    fillOpacity: 0.66
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.282 71.7733L105.643 77.593C105.028 78.2274 105.478 79.2889 106.361 79.2889H107.714C108.267 79.2889 108.714 79.7366 108.714 80.2889V86.4702C108.714 87.3768 109.824 87.8155 110.444 87.1539L117.422 79.706C118.021 79.0672 117.568 78.0222 116.693 78.0222H114C113.448 78.0222 113 77.5745 113 77.0222V72.4692C113 71.5706 111.907 71.128 111.282 71.7733Z",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_14573",
    x: 181.591,
    y: 60.65,
    width: 31.743,
    height: 7.09453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_1877_14573"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_14573",
    x: 181.591,
    y: 85.5289,
    width: 31.7469,
    height: 7.50078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_1877_14573"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1877_14573",
    x: 144.033,
    y: 71.2555,
    width: 33.3953,
    height: 9.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_1877_14573"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1877_14573",
    x: 10.8883,
    y: 59.4664,
    width: 32.0789,
    height: 7.55156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_1877_14573"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1877_14573",
    x: 10.8883,
    y: 85.6227,
    width: 32.0789,
    height: 7.55156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_1877_14573"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1877_14573",
    x: 46.5094,
    y: 71.357,
    width: 33.2664,
    height: 9.92656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_1877_14573"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1877_14573",
    x: 33.5367,
    y: 0.927345,
    width: 156.798,
    height: 156.966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.8,
    result: "effect1_foregroundBlur_1877_14573"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1877_14573_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "translate(-63.6 -31.6)",
    cx: 111.5,
    cy: 79.5,
    r: 23.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_14573",
    x1: 35.6758,
    y1: 15,
    x2: 35.6758,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1877_14573",
    x1: 57.7383,
    y1: 15,
    x2: 57.7383,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1877_14573",
    x1: 79.8047,
    y1: 15,
    x2: 79.8047,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1877_14573",
    x1: 101.875,
    y1: 15,
    x2: 101.875,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1877_14573",
    x1: 123.941,
    y1: 15,
    x2: 123.941,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1877_14573",
    x1: 146.008,
    y1: 15,
    x2: 146.008,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1877_14573",
    x1: 168.074,
    y1: 15,
    x2: 168.074,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1877_14573",
    x1: 190.137,
    y1: 15,
    x2: 190.137,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1877_14573",
    x1: 0.847656,
    y1: 132.043,
    x2: 223.353,
    y2: 132.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1877_14573",
    x1: 0.847656,
    y1: 110.887,
    x2: 223.353,
    y2: 110.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1877_14573",
    x1: 0.847656,
    y1: 89.7266,
    x2: 223.353,
    y2: 89.7266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1877_14573",
    x1: 0.847656,
    y1: 68.5703,
    x2: 223.353,
    y2: 68.5703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1877_14573",
    x1: 0.847656,
    y1: 47.4102,
    x2: 223.353,
    y2: 47.4102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1877_14573",
    x1: 182.191,
    y1: 64.197,
    x2: 212.712,
    y2: 64.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#460096",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1877_14573",
    x1: 182.191,
    y1: 89.2787,
    x2: 212.712,
    y2: 89.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#460096",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1877_14573",
    x1: 144.656,
    y1: 76.23,
    x2: 176.827,
    y2: 76.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#460096",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1877_14573",
    x1: 26.9399,
    y1: 65.9166,
    x2: 26.9399,
    y2: 60.5664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#BB81FE",
    stopOpacity: 0.6146
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7600FC",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1877_14573",
    x1: 26.9399,
    y1: 86.724,
    x2: 26.9399,
    y2: 92.0742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#BB81FE",
    stopOpacity: 0.6146
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7600FC",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1877_14573",
    x1: 63.1317,
    y1: 80.1851,
    x2: 51.1143,
    y2: 72.0995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608609,
    stopColor: "#7600FC",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1877_14573",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.5 79.5) rotate(90) scale(23.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532113,
    stopColor: "#9A38FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7600FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMevProtectIcon);
export default __webpack_public_path__ + "static/media/MEVProtectIcon.fe725bdd08080f324487d7dc0f036b2c.svg";
export { ForwardRef as ReactComponent };